import styled from 'styled-components'

export const SlackIntegrationSectionStyled = styled.div`
  width: 80%;
`

export const SlackIntegrationSectionLogoContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
`
